<kendo-dialog *ngIf="isQueueSelectionInProgress$ | async" (close)="cancel()" [minWidth]="250" [width]="450">
   <kendo-dialog-titlebar>
      <fa-icon [icon]="(purpose$ | async)?.titlebarIcon"></fa-icon>
      {{ (purpose$ | async)?.titlebarText | translate }}
   </kendo-dialog-titlebar>

   <div fxLayout="column">
      <ng-container *ngIf="callInfo$ | async as callInfo">
         <div fxFlex="1 2 0" class="call-info-description">
            <div fxFlex="30" class="call-info-description-text">
               {{ 'samwin.queue_selection_dialog.current_peer' | translate }}
            </div>
            <samweb-peer-info fxFlex="70" [call]="callInfo"></samweb-peer-info>
         </div>
         <div fxFlex="1 2 0" class="call-info-description last-call-info-description">
            <div fxFlex="30" class="call-info-description-text">
               {{ 'samwin.queue_selection_dialog.current_skill' | translate }}
            </div>
            <samweb-skill-short-info
               fxFlex="70"
               *ngIf="callInfo?.queueId as queueId"
               [skillConfiguration]="callInfo.queueId | skillIdToShortSkillInfo$ | async"
            ></samweb-skill-short-info>
         </div>
      </ng-container>

      <div fxFlex="1 2 0" class="info-text-box">
         {{ (purpose$ | async)?.infoText | translate }}
      </div>

      <div fxFlex="1 1 100%" class="data-item-container">
         <kendo-dropdownlist
            [data]="filteredSelectableQueues$ | async"
            [filterable]="true"
            [textField]="'name'"
            [valueField]="'id'"
            [loading]="isLoadingSelectableQueues$ | async"
            [value]="selectedQueue$ | async"
            (valueChange)="selectQueue($event)"
            (filterChange)="searchTextChanged($event)"
         >
            <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
               <fa-icon
                  [icon]="(dataItem.queueTypeId | toQueueType).icon"
                  [fixedWidth]="true"
                  *ngIf="dataItem"
               ></fa-icon>
               {{ dataItem?.name }}
            </ng-template>
            <ng-template kendoDropDownListNoDataTemplate>
               <h4>
                  <fa-icon [icon]="noDataIcon"></fa-icon><br /><br />
                  {{ 'samwin.queue_selection_dialog.no_queues_available' | translate }}
               </h4>
            </ng-template>
         </kendo-dropdownlist>
      </div>
   </div>

   <kendo-dialog-actions>
      <button kendoButton (click)="cancel()">{{ 'common.cancel' | translate }}</button>
      <button kendoButton (click)="ok()" primary="true" [disabled]="!(isQueueSelected$ | async)">
         <div class="sam-button-text">
            {{ 'common.ok' | translate }}
         </div>
      </button>
   </kendo-dialog-actions>
</kendo-dialog>
